module.exports = __webpack_public_path__ + "static/media/jason.e4d14fb3.jpg";